import { z } from 'zod';

function identifierOf(item: unknown): unknown {
  if (typeof item !== 'object' || item === null) return undefined;

  return (item as { id?: unknown }).id;
}

function describeIssues(error: z.ZodError): string {
  return error.issues.map(({ path, message }) => `${path.join('.')}: ${message}`).join(' | ');
}

export function tolerantArray<TSchema extends z.ZodTypeAny>(itemSchema: TSchema, source: string) {
  return z.array(z.unknown()).transform((items) =>
    items.flatMap((item): z.output<TSchema>[] => {
      const result = itemSchema.safeParse(item);

      if (result.success) return [result.data];

      console.warn(
        `[api] item ignorado em ${source}`,
        identifierOf(item),
        describeIssues(result.error),
      );

      return [];
    }),
  );
}
